module.exports = __webpack_public_path__ + "static/img/weather_039.ebaf16e8.svg";